/**
 * Application Route Paths
 * Centralized routing configuration
 *
 * Structure follows: [FEATURE].[PAGE]
 */
export const PATHS = {
  // Public
  ROOT: '/',
  LOGIN: '/login',
  OAUTH2_CALLBACK: '/oauth2/callback',
  CHANGE_PASSWORD: '/change-password',
  FORBIDDEN: '/403',
  NOT_FOUND: '/404',

  // Dashboard / Landing
  DASHBOARD: '/dashboard',

  // Admin Module
  ADMIN: {
    ROOT: '/admin',

    // User Management
    USERS: {
      LIST: '/admin/users',
      CREATE: '/admin/users/create',
      BULK_CREATE: '/admin/users/bulk-create',
      DETAIL: (id: string) => `/admin/users/${id}`,
    },

    // Role Management
    ROLES: {
      LIST: '/admin/roles',
      CREATE: '/admin/roles/create',
      DETAIL: (id: string) => `/admin/roles/${id}`,
    },

    // Permission Management
    PERMISSIONS: {
      LIST: '/admin/permissions',
    },

    // Apps Management
    APPS: {
      LIST: '/admin/apps',
    },

    // Reports
    REPORTS: {
      LIST: '/admin/reports',
    },

    // Organization
    ORGANIZATION: {
      LIST: '/admin/organization',
      // Company Management
      COMPANIES: {
        LIST: '/admin/organization/companies',
        CREATE: '/admin/organization/companies/create',
        DETAIL: (id: string) => `/admin/organization/companies/${id}`,
      },
      // Department Management
      DEPARTMENTS: {
        LIST: '/admin/organization/departments',
        CREATE: '/admin/organization/departments/create',
        DETAIL: (id: string) => `/admin/organization/departments/${id}`,
      },
    },

    // Settings
    SETTINGS: {
      LIST: '/admin/settings',
    },

    // Activity Log
    ACTIVITY: {
      LIST: '/admin/activity',
    },

    // Report Filters
    REPORT_FILTERS: {
      LIST: '/admin/report-filters',
      CREATE: '/admin/report-filters/create',
      BULK_CREATE: '/admin/report-filters/bulk-create',
      DETAIL: (id: string) => `/admin/report-filters/${id}`,
    },

    // Chatbots
    CHATBOTS: {
      LIST: '/admin/chatbots',
      CREATE: '/admin/chatbots/create',
      DETAIL: (id: string) => `/admin/chatbots/${id}`,
    },

    // System Configuration
    SYSTEM: {
      ROOT: '/admin/system',
    },

    //Profile
    PROFILE: {
      ROOT: '/admin/profile',
    },
  },

  REPORT_VIEW: '/report/view',

  // Themes (if needed)
  THEMES: '/themes',
} as const;

export default PATHS;
